import { MODALS } from './types';

const historyModals = new Set<MODALS>();

export const modalHistoryState = {
  get entryCount() {
    return historyModals.size;
  },
  skipPopstateCount: 0,
};

export const pushModalHistoryEntry = (modal: MODALS) => {
  window.history.pushState({ modalHistoryEntry: true }, '');
  historyModals.add(modal);
};

export const cleanupModalHistoryEntry = (modal?: MODALS) => {
  if (modal !== undefined) {
    if (!historyModals.has(modal)) return;
    historyModals.delete(modal);
  } else {
    if (historyModals.size === 0) return;
    const last = Array.from(historyModals).pop()!;
    historyModals.delete(last);
  }
  modalHistoryState.skipPopstateCount++;
  window.history.back();
};

export const handlePopstateClose = (): boolean => {
  if (modalHistoryState.skipPopstateCount > 0) {
    modalHistoryState.skipPopstateCount--;
    return false;
  }
  if (historyModals.size > 0) {
    const last = Array.from(historyModals).pop()!;
    historyModals.delete(last);
    return true;
  }
  return false;
};

export const cleanupAllModalHistoryEntries = () => {
  const count = historyModals.size;
  if (count > 0) {
    modalHistoryState.skipPopstateCount += count;
    historyModals.clear();
    window.history.go(-count);
  }
};

export const resetModalHistoryState = () => {
  historyModals.clear();
  modalHistoryState.skipPopstateCount = 0;
};
